import ReactLoading from 'react-loading';
import { useState } from 'react';
import { TextField, Autocomplete } from '@mui/material';
import { Button } from 'components';
import { ModalCard } from './style';
import { secondary } from 'styles/colorProvider';
import { listBrands, listModels, listYearModels, getFipe } from 'api/fipe/fipeService';

export const NewFipeSearch = ({ onFinish }) => {
  const [vehicleData, setVehicleData] = useState();
  const [selectsIsLoading, setSelectsIsLoading] = useState({});
  const [selecstOptionsList, setSelectsOptionsList] = useState({
    vehicleType: [
      { Value: 1, Label: 'Carro' },
      { Value: 7, Label: 'Moto' },
    ],
    brand: [],
    model: [],
    version: [],
  });

  const handleListBrands = async (vehicleType) => {
    setSelectsIsLoading({ ...selectsIsLoading, brandList: true });
    try {
      const brands = await listBrands({ type: vehicleType.Value });
      setSelectsOptionsList({ ...selecstOptionsList, brand: brands });
      setSelectsIsLoading({ ...selectsIsLoading, brandList: false });
    } catch (error) {
      setSelectsIsLoading({ ...selectsIsLoading, brandList: false });
    }
  };

  const handleListModels = async (vehicleBrand, typeId) => {
    setSelectsIsLoading({ ...selectsIsLoading, modelsList: true });
    try {
      const models = await listModels({ brand: vehicleBrand, type: typeId });
      setSelectsOptionsList({ ...selecstOptionsList, model: models });
      setSelectsIsLoading({ ...selectsIsLoading, modelsList: false });
    } catch (error) {
      setSelectsIsLoading({ ...selectsIsLoading, modelsList: false });
    }
  };

  const handleListVersions = async (vehicleModel, brandId, typeId) => {
    setSelectsIsLoading({ ...selectsIsLoading, versionsList: true });
    try {
      const versions = await listYearModels({ model: vehicleModel, brand: brandId, type: typeId });
      setSelectsOptionsList({ ...selecstOptionsList, version: versions });
      setSelectsIsLoading({ ...selectsIsLoading, versionsList: false });
    } catch (error) {
      setSelectsIsLoading({ ...selectsIsLoading, versionsList: false });
    }
  };

  const handleGetFipe = async (yearModelValue, fuelCode, brandId, modelId, typeId) => {
    setSelectsIsLoading({ ...selectsIsLoading, getFipe: true });
    try {
      const data = await getFipe({
        fuel: fuelCode,
        yearModel: yearModelValue,
        model: Number(modelId),
        brand: Number(brandId),
        type: Number(typeId),
      });
      setVehicleData({
        ...vehicleData,
        brand: data?.brand,
        model: data?.model,
        fipe_code: data?.fipe_code,
        value: data?.value,
        year: data?.year,
        id_fuel: data?.id_fuel,
        fuel: data?.fuel,
      });
      setSelectsIsLoading({ ...selectsIsLoading, getFipe: false });
    } catch (error) {
      setSelectsIsLoading({ ...selectsIsLoading, getFipe: false });
    }
  };

  return (
    <ModalCard>
      <div className="centralizer">
        <h1>Procurar veículo</h1>

        {/* VEHICLE TYPE */}
        <Autocomplete
          disabled={selectsIsLoading.vehicleType}
          loading={selectsIsLoading.vehicleType}
          loadingText="Carregando..."
          options={selecstOptionsList.vehicleType || []}
          noOptionsText="Sem opções..."
          sx={{ width: 310 }}
          getOptionLabel={(option) => {
            return option?.Label;
          }}
          value={vehicleData?.type}
          onChange={(event, data) => {
            setVehicleData({ ...vehicleData, type: data.Value });
            handleListBrands(data);
          }}
          renderOption={(props, option) => {
            return (
              <p style={{ paddingLeft: 10, cursor: 'pointer' }} {...props} className="title">
                {option?.Label}
              </p>
            );
          }}
          renderInput={(params) => (
            <TextField disabled={false} {...params} label="Selecione o tipo" placeholder="Digite para buscar..." />
          )}
        />

        {/* VEHICLE BRAND */}
        {selectsIsLoading.brandList && <ReactLoading color={secondary} height={24} width={24} type="bubbles" />}
        <Autocomplete
          disabled={selectsIsLoading.brandList || selecstOptionsList?.brand?.length < 1}
          loading={selectsIsLoading.brandList}
          loadingText="Carregando..."
          options={selecstOptionsList?.brand || []}
          noOptionsText="Sem opções..."
          sx={{ width: 310 }}
          getOptionLabel={(option) => {
            return option.Label;
          }}
          onChange={(event, data) => {
            setVehicleData({ ...vehicleData, id_brand: data.Value });
            handleListModels(data.Value, vehicleData?.type);
          }}
          renderOption={(props, option) => (
            <p style={{ paddingLeft: 10, cursor: 'pointer' }} {...props} className="title">
              {option?.Label}
            </p>
          )}
          renderInput={(params) => (
            <TextField disabled={false} {...params} label="Selecione a marca" placeholder="Digite para buscar..." />
          )}
          value={vehicleData?.type.brand}
        />

        {/* VEHICLE MODEL */}
        {selectsIsLoading.modelsList && <ReactLoading color={secondary} height={24} width={24} type="bubbles" />}
        <Autocomplete
          disabled={selectsIsLoading.model || selecstOptionsList?.model?.length < 1}
          loading={selectsIsLoading.model}
          loadingText="Carregando..."
          options={selecstOptionsList?.model || []}
          noOptionsText="Sem opções..."
          sx={{ width: 310 }}
          getOptionLabel={(option) => {
            return option.Label;
          }}
          onChange={(event, data) => {
            setVehicleData({ ...vehicleData, id_model: data.Value });
            handleListVersions(data.Value, vehicleData?.id_brand, vehicleData?.type);
          }}
          renderOption={(props, option) => (
            <p style={{ paddingLeft: 10, cursor: 'pointer' }} {...props} className="title">
              {option?.Label}
            </p>
          )}
          renderInput={(params) => (
            <TextField disabled={false} {...params} label="Selecione o modelo" placeholder="Digite para buscar..." />
          )}
          value={vehicleData?.type.model}
          isOptionEqualToValue={(option, value) => {
            return option.Value === value.Value;
          }}
        />

        {/* VEHICLE YEAR MODEL */}
        {selectsIsLoading.versionsList && <ReactLoading color={secondary} height={24} width={24} type="bubbles" />}
        <Autocomplete
          disabled={selectsIsLoading.version || selecstOptionsList?.version?.length < 1}
          loading={selectsIsLoading.version}
          loadingText="Carregando..."
          options={selecstOptionsList?.version || []}
          noOptionsText="Sem opções..."
          sx={{ width: 310 }}
          getOptionLabel={(option) => {
            return option.Label;
          }}
          onChange={(event, data) => {
            const fuelStr = data.Label?.split(' ')[1];
            const fuelCode = fuelStr === 'Gasolina' ? 1 : fuelStr === 'Diesel' ? 3 : 2;
            setVehicleData({ ...vehicleData, yearModel: data.Value });
            handleGetFipe(data.Value, fuelCode, vehicleData?.id_brand, vehicleData?.id_model, vehicleData?.type);
          }}
          renderOption={(props, option) => (
            <p style={{ paddingLeft: 10, cursor: 'pointer' }} {...props} className="title">
              {option?.Label}
            </p>
          )}
          renderInput={(params) => <TextField {...params} label="Selecione a versão" placeholder="Digite para buscar..." />}
          value={vehicleData?.yearModel}
          isOptionEqualToValue={(option, value) => {
            return option?.Value === value?.Value;
          }}
        />

        {selectsIsLoading.getFipe && <ReactLoading color={secondary} height={24} width={24} type="bubbles" />}
        <Button
          loading={selectsIsLoading?.getFipe}
          disabled={!vehicleData?.value}
          width="300px"
          style={{ marginTop: 20, marginBottom: 50 }}
          onClick={() => {
            const data = {
              type: vehicleData?.type,
              id_brand: vehicleData?.id_brand,
              brand: vehicleData?.brand,
              id_model: vehicleData?.id_model,
              model: vehicleData?.model,
              year: vehicleData?.year,
              build_year: vehicleData?.year,
              value: vehicleData?.value,
              id_fuel: vehicleData?.id_fuel,
              fuel: vehicleData?.fuel,
              fipe_code: vehicleData?.fipe_code,
              id_type: vehicleData?.type,
            };
            onFinish(data);
          }}
        >
          Selecionar
        </Button>
      </div>
    </ModalCard>
  );
};
